<script lang="ts">
  import { reveal } from '../actions';
</script>

<section class="legend wrap reveal" id="legend" use:reveal>
  <div class="legend__inner">
    <div class="legend__t">Как читать</div>
    <p class="legend__rule">
      Способность считается развитой не тогда, когда она пережита ярко,
      а когда её механизм понятен, граница честна, источник назван,
      и она выдерживает проверку в сосуде реальной жизни.
    </p>
    <div class="legend__grid">
      <div class="lg">
        <span class="lg__m">☿</span>
        <div>
          <b>Струна</b>
          <span>глиф у узла показывает, к какому течению он принадлежит — и где перерождается на других уровнях</span>
        </div>
      </div>
      <div class="lg">
        <span class="lg__m dots">
          <i style="background:var(--mercury)"></i>
          <i style="background:var(--gold)"></i>
          <i style="background:var(--rubedo)"></i>
        </span>
        <div>
          <b>Метка регистра</b>
          <span>уверенно · спорно · тонко (карты&nbsp;I–II) · имагинальное (III) · за&nbsp;линией (IV)</span>
        </div>
      </div>
      <div class="lg">
        <span class="lg__m">⊕</span>
        <div>
          <b>Раскрыть узел</b>
          <span>коснись — механизм простым языком, лестница развития, связи между регистрами</span>
        </div>
      </div>
      <div class="lg">
        <span class="lg__m">∿</span>
        <div>
          <b>Струны</b>
          <span>раздел внизу: проследи одну способность сквозь все четыре карты</span>
        </div>
      </div>
      <div class="lg">
        <span class="lg__m">✶</span>
        <div>
          <b>Печать</b>
          <span>у каждой способности свой сигил — собран из имени, струны и стадии, всегда одинаков</span>
        </div>
      </div>
    </div>
  </div>
</section>
